<script>
    import {getContext, createEventDispatcher, onDestroy} from "svelte";
    import {fade} from 'svelte/transition';
    import {to, API} from "@API";

    let ValidateCoupon = API.service('shop/:product_slug/validate_coupon');
    let ApplyCoupon = API.service('stripe/:subscription/apply_coupon');

    let dispatch = createEventDispatcher();

    let {org, product, shopData, serviceProviders, matchkey, location} = getContext("SHOP");

    export let hidewrapper = false;
    let providerError = '';
    let locationError = '';
    let forceSelectLocation = false;

    export let step;
    export let stepComplete;

    $shopData.productType = "single";
    const serviceProviderTypes = {
        Health: 'Doctor',
        Gym: 'Coach',
        'Tactical & First Responders': "Director"
    }

    const unsubscribe = serviceProviders.subscribe(providers => {
        if (providers && providers.length === 1) {
            $shopData.serviceProvider = providers[0];
        }
    })

    function onContinue(){
      if(step.validate()){
        stepComplete()
      }
    }

    onDestroy(unsubscribe);

</script>

<style type="text/scss">

  .checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    user-select: none;

    & > * {
      margin: .5rem 0.5rem;
    }

  }

  .checkbox-group-legend {
    font-size: 1.5rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    line-height: 1.125;
    margin-bottom: 1.25rem;
  }

  .checkbox-input {
    // Code to hide the input
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:checked + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1);
      color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
        background-color: black;
        border-color: black;
      }

      .checkbox-icon, .checkbox-label {
        color: black;
      }
    }

    &:focus + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1), 0 0 0 4px #b5c9fc;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 7rem;
    min-height: 7rem;
    border-radius: 0.5rem;
    border: 2px solid #b5bfd9;
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(#000, 0.1);
    transition: 0.15s ease;
    cursor: pointer;
    position: relative;

    &.location {
      margin: 0 1.5rem;
      width: 9rem;
      height: 100%;
      padding: 0.5rem;
    }

    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid #b5bfd9;
      background-color: #fff;
      border-radius: 50%;
      top: 0.25rem;
      left: 0.25rem;
      opacity: 0;
      transform: scale(0);
      transition: 0.25s ease;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' fill='%23FFFFFF' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpolyline points='216 72.005 104 184 48 128.005' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'%3E%3C/polyline%3E%3C/svg%3E");
      background-size: 12px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }

    &:hover {
      border-color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-icon {
    transition: .375s ease;
    color: #494949;

    i {
      font-size: 50px;
    }
  }

  .checkbox-label {
    color: #707070;
    transition: .375s ease;
    text-align: center;
  }

  .customer-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 1200px) {
      padding-left: 20px;
    }

  }

  .coupon-input {
    display: flex;
    align-items: center;
    width: 100%;

    input {
      width: 100%
    }

    button {
      font-size: 10px;
      width: 160px;
      margin: 0;
    }

    i {
      position: absolute;
      right: 130px;
      color: #0abb0a;
    }

  }

  .options {
    margin:auto;
  }
</style>


<div class="options">
    <h1 class='text-gray-700'>Choose Your Product Path</h1>
    <p class="my-3 text-gray-400">Are you purchasing as a couple or individual?</p>
    <div class="checkbox-group">
        <div class="checkbox">
            <label class="checkbox-wrapper">
                <input type="radio" class="checkbox-input" bind:group={$shopData.productType} name="single" value="single"/>
                <span class="checkbox-tile">
            <span class="checkbox-icon">
              <i class="fa-duotone fa-person"></i>
            </span>
            <span class="checkbox-label">Individual</span>
          </span>
            </label>
        </div>
        <div class="checkbox">
            <label class="checkbox-wrapper">
                <input type="radio" class="checkbox-input" bind:group={$shopData.productType} name="couple" value="couple"/>
                <span class="checkbox-tile">
            <span class="checkbox-icon">
              <i class="fa-duotone fa-people-pants-simple"></i>
            </span>
            <span class="checkbox-label">Couple</span>
          </span>
            </label>
        </div>
    </div>

    <button type="button" on:click={onContinue}
            class="mb-4 min-w-[330px] w-1/2 mx-auto mt-5 items-center rounded-md border border-transparent bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Continue
    </button>

</div>
